import { shadeColor } from '@app/utils/utils';
import { graphic } from 'echarts';
import { BASE_COLORS } from '../constants';
import { ITheme } from '../types';

const chartColors = {
  chartTooltipLabel: '#A1A1AA',
  chartColor1: '#60A5FA',
  chartColor1Tint: '#93C5FD',
  chartColor2: '#2DD4BF',
  chartColor2Tint: '#5EEAD4',
  chartColor3: '#FBBF24',
  chartColor3Tint: '#FDE68A',
  chartColor4: '#4ADE80',
  chartColor4Tint: '#86EFAC',
  chartColor5: '#F87171',
  chartColor5Tint: '#FCA5A5',
  chartPrimaryGradient: new graphic.LinearGradient(0, 0, 0, 1, [
    {
      offset: 0,
      color: 'rgba(96, 165, 250, 0.28)'
    },
    {
      offset: 1,
      color: 'rgba(96, 165, 250, 0)'
    }
  ]),
  chartSecondaryGradient: new graphic.LinearGradient(0, 0, 0, 1, [
    {
      offset: 0,
      color: 'rgba(255, 82, 82, 0.35)'
    },
    {
      offset: 1,
      color: 'rgba(255, 82, 82, 0)'
    }
  ]),
  chartSecondaryGradientSpecular: new graphic.LinearGradient(0, 0, 0, 1, [
    {
      offset: 0,
      color: 'rgba(255, 255, 255, 0)'
    },
    {
      offset: 1,
      color: 'rgba(255, 82, 82, 0.5)'
    }
  ])
};

export const darkColorsTheme: ITheme = {
  logoText: '#F4F4F5',
  logoTextSpan: '#60A5FA',
  primary: '#60A5FA',
  primary1: '#172554',
  primaryGradient: 'linear-gradient(135deg, #2563EB 0%, #0891B2 100%)',
  secondaryGradient: 'linear-gradient(135deg, #18181B 0%, #1E3A8A 100%)',
  light: '#3F3F46',
  secondary: '#38BDF8',
  error: '#F87171',
  warning: '#FBBF24',
  success: '#4ADE80',
  background: '#18181B',
  secondaryBackground: '#111113',
  secondaryBackgroundSelected: shadeColor('#111113', -5),
  additionalBackground: '#202024',
  collapseBackground: '#2563EB',
  timelineBackground: '#18181B',
  siderBackground: '#151518',
  spinnerBase: '#60A5FA',
  scroll: '#3F3F46',
  border: '#2A2A2E',
  borderNft: '#3F3F46',
  textMain: '#F4F4F5',
  textLight: '#A1A1AA',
  textSuperLight: '#71717A',
  textSecondary: '#E4E4E7',
  textDark: '#18181B',
  textNftLight: '#A1A1AA',
  textSiderPrimary: '#93C5FD',
  textSiderSecondary: '#D4D4D8',
  subText: '#A1A1AA',
  shadow: 'rgba(0, 0, 0, 0.35)',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.35)',
  boxShadowHover: '0 10px 24px rgba(0, 0, 0, 0.45)',
  boxShadowNft:
    '0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
  boxShadowNftSecondary:
    '0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
  dashboardMapBackground: '#18181B',
  dashboardMapCircleColor: '#3B82F6',
  dashboardMapControlDisabledBackground: '#3F3F46',
  notificationSuccess: '#052E1A',
  notificationPrimary: '#172554',
  notificationWarning: '#451A03',
  notificationError: '#450A0A',
  heading: BASE_COLORS.white,
  borderBase: '#3F3F46',
  disable: '#71717A',
  disabledBg: '#27272A',
  layoutBodyBg: '#111113',
  layoutHeaderBg: '#111113',
  layoutSiderBg: '#151518',
  inputPlaceholder: '#71717A',
  itemHoverBg: '#27272A',
  backgroundColorBase: '#27272A',
  avatarBg: '#27272A',
  alertTextColor: '#FFFFFF',
  breadcrumb: '#A1A1AA',
  icon: '#A1A1AA',
  iconHover: '#F4F4F5',
  ...chartColors
};

export const antDarkColorsTheme = {
  successBg: '#e6fff2',
  successBorder: '#79fcc4'
};
